import * as React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import { Box, SxProps } from '@mui/material';


type Props = {
    title?: string,
    open: boolean,
    onClose: () => void,
    children: React.ReactNode,
    size?: 'lg' | 'md' | 'sm' | 'xl',
    sx?: SxProps,
    disabledCloseOnEscape?: boolean
    disabledCloseOnBackdropClick?: boolean,
    fullScreen?: boolean,
    fullHeight?: boolean,
    padding?: number
}

const styles = {
    dialogPaper: {
        minHeight: '100%',
        maxHeight: '100%',
    },
};

const SimpleDialog = ({ title, children, open, onClose, size = 'lg', sx, padding = 5, disabledCloseOnEscape = true, disabledCloseOnBackdropClick = true, fullScreen = false, fullHeight = true }: Props) => {
    const handleClose = (e: React.SyntheticEvent, reason: 'backdropClick' | 'escapeKeyDown') => {
        if (disabledCloseOnBackdropClick && reason === 'backdropClick') {
            return;
        }

        onClose();
    };

    //onClick={(e: MouseEvent) => e.preventDeafult()}    

    return (
        <Dialog PaperProps={{
            sx: { height: fullHeight ? '100%' : undefined }
        }} onClose={handleClose} open={open} fullWidth maxWidth={size} disableEscapeKeyDown={disabledCloseOnEscape} fullScreen={fullScreen} sx={{ height: fullHeight ? '100%' : undefined }}>
            <Box sx={{ padding: fullScreen ? 0 : padding, ...sx, height: '100%', display: 'flex', flexDirection: 'column' }} >
                {title && <DialogTitle>{title}</DialogTitle>}
                {children}
            </Box>
        </Dialog>
    );
}

export { SimpleDialog }
export default SimpleDialog;